import {
  put,
  call,
  takeEvery,
} from 'redux-saga/effects';
import { ContentManagementService } from '../services';
import { ActionTypes } from '../constants';

async function fetchAsync(func: any, arg: any) {
  try {
    const response = arg !== null ? await func(arg) : await func();
    return response;
  } catch (error: any) {
    return {
      error: true,
      message: error.response.data.message,
      status: error.response.data.statusCode,
    };
  }
}

function* FAQS(action: any): Generator {
  try {
    const data:any = yield call(fetchAsync, ContentManagementService.getFAQS, action.payload);
    if (data.error) {
      if (data.status === 403) {
        yield put({ type: ActionTypes.LOGOUT_WITH_ERROR_REQUEST });
      } else {
        yield put({ type: ActionTypes.FAQS_MGMT_LIST_REQUEST, payload: data.message });
      }
    } else {
      yield put({ type: ActionTypes.FAQS_MGMT_LIST_SUCCESS, payload: data.data.data });
    }
  } catch (e: any) {
    yield put({ type: ActionTypes.FAQS_MGMT_LIST_ERROR, error: e.data });
  }
}

export function* watchFAQsSaga() {
  yield takeEvery(ActionTypes.FAQS_MGMT_LIST_REQUEST, FAQS);
}
export default watchFAQsSaga;
